// extracted by mini-css-extract-plugin
module.exports = {"FrontInfoBoxes":"FrontInfoBoxes_FrontInfoBoxes__3WZ4k"};